var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C14.5562 0.000132456 18.25 3.69373 18.25 8.25C18.25 9.20378 17.9233 10.2343 17.4561 11.2354C16.9839 12.2469 16.3398 13.2881 15.6436 14.2793C14.2509 16.2621 12.6035 18.1072 11.5674 19.21C10.7116 20.1208 9.28844 20.1207 8.43262 19.21C7.39656 18.1073 5.74915 16.2621 4.35645 14.2793C3.66022 13.2881 3.01609 12.2469 2.54395 11.2354C2.07671 10.2343 1.75 9.20381 1.75 8.25C1.75 3.69365 5.44365 0 10 0ZM10 1.5C6.27208 1.5 3.25 4.52208 3.25 8.25C3.25 8.88741 3.47635 9.68574 3.90332 10.6006C4.32541 11.5049 4.917 12.4674 5.58398 13.417C6.91777 15.3159 8.51008 17.103 9.52539 18.1836C9.78875 18.4635 10.2113 18.4636 10.4746 18.1836C11.4899 17.1029 13.0823 15.3159 14.416 13.417C15.083 12.4674 15.6746 11.5049 16.0967 10.6006C16.5236 9.68578 16.75 8.88739 16.75 8.25C16.75 4.52216 13.7278 1.50013 10 1.5ZM10 3.59961C12.2227 3.59987 14.0254 5.40222 14.0254 7.625C14.0254 9.84778 12.2227 11.6501 10 11.6504C7.77705 11.6504 5.97461 9.84795 5.97461 7.625C5.97461 5.40205 7.77705 3.59961 10 3.59961ZM10 5.40039C8.77117 5.40039 7.77539 6.39617 7.77539 7.625C7.77539 8.85383 8.77117 9.84961 10 9.84961C11.2286 9.84935 12.2246 8.85367 12.2246 7.625C12.2246 6.39633 11.2286 5.40065 10 5.40039Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 7.625,
    rx: 3.125,
    ry: 3.125,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/Location_Icon.3cbe921d76879325226f2d006f394c9d.svg";
export { ForwardRef as ReactComponent };